import React from "react";
import { string, node } from "prop-types";
import { twMerge } from "tailwind-merge";

const MobileContainer = ({ children, className, ...props }) => {
  return (
    <div className={twMerge("flex w-full lg:hidden", className)} {...props}>
      {children}
    </div>
  );
};

MobileContainer.propTypes = {
  children: node.isRequired,
  className: string,
};

export default MobileContainer;
